(function () {
    'use strict';

    function contenteditable($timeout, $sce) {
        return {
            restrict: 'A',
            require: "ngModel",
            scope: {
                changeEvent: '&',
            },
            link: function (scope, element, attrs, ngModel) {
                if (!ngModel) return; // do nothing if no ng-model

                // Specify how UI should be updated
                ngModel.$render = function () {
                    element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
                };

                element.on("blur", function () {
                    saveChanges();
                });

                element.on("mouseover", function () {
                    element.addClass('content-editing-hover');
                });

                element.on("mouseout", function () {
                    element.removeClass('content-editing-hover');
                });

                element.on("click",
                    function() {
                        element.removeClass('content-editing-hover');
                        element.addClass('content-editing');
                    });

                element.on("keydown", function (e){
                    // handle enter key - save the element
                    if(e.keyCode == 13 && element.hasClass('content-editing')) {
                        e.preventDefault();
                        e.stopPropagation();
                        saveChanges();
                        element.blur();
                    }
                })

                function saveChanges() {
                    element.removeClass('content-editing');
                    scope.$evalAsync(read);
                    $timeout(function() { scope.changeEvent(); }, 0);
                }
                
                // Write data to the model
                function read() {
                    var html = element.html();
                    // When we clear the content editable the browser leaves a <br> behind
                    // If strip-br attribute is provided then we strip this out
                    // strip all html tags
                    if (attrs.stripBr && html == '<br>') {
                        html = '';
                    }

                    var stripped = html.replace(/(<([^>]+)>)/gi, "");
                    stripped = stripped.replace('&nbsp;', '');

                    ngModel.$setViewValue(stripped);
                }
            }
        };
    }

    contenteditable.$inject = ['$timeout', '$sce'];

    angular.module('ecap.common').directive('contenteditable', contenteditable);
})();